<img src="assets/images/TetraConnect_logo.svg" alt="logo" class="logo" />
<div>
    <app-contact-us />
    <app-representation-dropdown />
    <app-topbar-dropdown />
</div>
